"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosLoggerInterceptor = void 0;
class AxiosLoggerInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    addRequestInterceptor() {
        this.axiosInstance.registerRequestInterceptor((config) => {
            var _a;
            console.log(`%c[REQUEST]`, 'color: green');
            console.table({
                Method: (_a = config === null || config === void 0 ? void 0 : config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
                URL: config.url,
            });
            return config;
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor((response) => {
            var _a, _b;
            console.log(`%c[RESPONSE]`, 'color: blue');
            console.table({
                Status: response.status,
                Method: (_b = (_a = response.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
                URL: response.config.url,
                Data: response.data,
            });
            return response;
        });
    }
}
exports.AxiosLoggerInterceptor = AxiosLoggerInterceptor;
//# sourceMappingURL=AxiosLoggerInterceptor.js.map